import Vue from "vue";
import Meta from "vue-meta";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "@/router";
import store from "@/store";
import BootstrapVue from "bootstrap-vue";
import plugins from "@/plugins";
import CoreUiVue from "@coreui/vue";
import i18n from "@/i18n";
import {
  extend,
  configure
} from "vee-validate";
import {
  loadVeeValidateExtend
} from "./plugins/vee-validate";
import * as rules from "vee-validate/dist/rules";
import {
  iconsSet as icons
} from "./assets/icons/icons.js";
import moment from "moment";
import Select2 from "v-select2-component";
import AuthLayout from "./components/layouts/AuthLayout.vue";
import GuestLayout from "./components/layouts/GuestLayout";
import ErrorLayout from "./components/layouts/ErrorLayout";
import DocumentLayout from "./components/layouts/DocumentLayout";
import VueMask from "v-mask";
import money from 'v-money';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/styles/style.scss";
import VueImg from "v-img";
import VCalendar from "v-calendar";
import VueMarkdown from "vue-markdown";
import 'ant-design-vue/dist/antd.css';
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import VueCompositionApi from '@vue/composition-api'
import Vuelidate from "@vuelidate/core";
import VuelidateErrorExtractor, {templates} from "vuelidate-error-extractor";
import ScrollLoader from 'vue-scroll-loader'
import Antd from 'ant-design-vue';
import CKEditor from '@ckeditor/ckeditor5-vue2';

Vue.use(CKEditor);
Vue.use(Antd);
Vue.use(VCalendar, {
  componentPrefix: "vc"
});
Vue.use(ScrollLoader)

configure({
  defaultMessage: (field, values) => {
    // override the field name.
    values._field_ = i18n.t(`fields.${field}`);

    if (field === "password_confirm") {
      values.target = i18n.t(`fields.target.${field}`);
    }

    return i18n.t(`validation.${values._rule_}`, values);
  }
});
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(CoreUiVue);
Vue.use(Meta);
Vue.use(plugins);
// Vue.use(Antd);
Vue.use(VueCompositionApi)
const vueImgConfig = {
  // Use `alt` attribute as gallery slide title
  altAsTitle: false,
  // Display 'download' button near 'close' that opens source image in new tab
  sourceButton: false,
  // Event listener to open gallery will be applied to <img> element
  openOn: "click",
  // Show thumbnails for all groups with more than 1 image
  thumbnails: false
};
Vue.use(VueImg, vueImgConfig);
Vue.use(Vuelidate);
Vue.use(VuelidateErrorExtractor, {
  i18n: false,
  template: templates.singleErrorExtractor.foundation6
});
loadVeeValidateExtend();
Vue.component("AuthLayout", AuthLayout);
Vue.component("GuestLayout", GuestLayout);
Vue.component("VueMarkdown", VueMarkdown);
Vue.component("ErrorLayout", ErrorLayout);
Vue.component("DocumentLayout", DocumentLayout);
Vue.component("Select2", Select2);
Vue.component("FormGroup", templates.singleErrorExtractor.foundation6);
Vue.use("DatePicker", DatePicker);
Vue.use(VueMask);
Vue.use(money, {precision: 0});
Vue.filter("formatDate", function (date) {
  if (!date) return "";
  let d = moment(date, "YYYY-MM-DD");
  return d.format("DD/MM/YYYY");
});
Vue.filter("formatDateTime", function (date) {
  if (!date) return "";
  let d = moment(date, "YYYY-MM-DD HH:mm:ss");
  return d.format("DD/MM/YYYY HH:mm:ss");
});
Vue.filter("formatHour", function (date) {
  if (!date) return "";
  let d = moment(date, "hh:mm:ss");
  return d.format("HH:mm");
});
Vue.filter("formatHourRemote", function (date) {
  if (!date) return "";
  let d = moment(date, "hh:mm:ss");
  return d.format("hh:mm:ss");
});
Vue.filter("formatDateDay", function (date) {
  if (!date) return "";
  let d = moment(date, "YYYY-MM-DD");
  return d.lang('en').format("dddd, DD/MM/YYYY");
});
Vue.filter('currency', function (number) {
  return new Intl.NumberFormat('vi').format(number);
});
moment.updateLocale('en', {
  weekdays: [
    i18n.t('overtime.day_of_week.sunday'),
    i18n.t('overtime.day_of_week.monday'),
    i18n.t('overtime.day_of_week.tuesday'),
    i18n.t('overtime.day_of_week.wednesday'),
    i18n.t('overtime.day_of_week.thursday'),
    i18n.t('overtime.day_of_week.friday'),
    i18n.t('overtime.day_of_week.saturday'),
  ]
});
new Vue({
  i18n,
  router,
  store,
  icons,
  ...App
}).$mount("#app");
